import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import './App.css';
import AboutUs from "./pages/About";
import Home from "./pages/Home";
import Project from "./pages/project";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/footer";
import ContactUs from "./pages/Contact";
// SERVICES
import AndroidAppDev from "./pages/Services/androidapp";
import AiAppDev from "./pages/Services/aiapp";
import PythonDev from "./pages/Services/pythondev";
import ContentWriter from "./pages/Services/content_writer";
import CyberSecurity from "./pages/Services/cyber_security";
import Devops from "./pages/Services/devops";
import DigitalMarketing from "./pages/Services/digital_marketing";
import IOTDev from "./pages/Services/iot";
import WebSiteDev from "./pages/Services/websitedev";
import SEO from "./pages/Services/seo";
import QAAutomationTesting from "./pages/Services/qaautomation";
// INDUSTRIES
import BankingAndFinancial from "./pages/Industries/banking&financial";
import Education from "./pages/Industries/education";
import EnergyResourcesUtilities from "./pages/Industries/energy&resources";
import Insurance from "./pages/Industries/insurance";
import LifeScienceHealthcare from "./pages/Industries/life_healthcare";
import PublicServices from "./pages/Industries/public&services";
import CommunicationMedia from "./pages/Industries/communicationmedia";
import TravelMediaLogistics from "./pages/Industries/travel&trans&log";
import InformationServices from "./pages/Industries/consumergoods";
// PROJECTS
import Constrogen from "./pages/Projects/constrogen";
import VBY from "./pages/Projects/vby";
import IntelliReader from "./pages/Projects/intellireader";
import Skarvi from "./pages/Projects/skarvi";
import EMS from "./pages/Projects/ems";
import Vibro from "./pages/Projects/vibro";
function App() {
  return (
    <Router>
      <Navbar />
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projects" element={<Project/>} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/contact-us" element={<ContactUs />} />
          {/* SERVICES */}
          <Route path="/android-app-development" element={<AndroidAppDev />} />
          <Route path="/ai-app-development" element={<AiAppDev />} />
          <Route path="/python-development" element={<PythonDev />} />
          <Route path="/content-writer" element={<ContentWriter />} />
          <Route path="/cyber-security" element={<CyberSecurity />} />
          <Route path="/devops" element={<Devops />} />
          <Route path="/digital-marketing" element={<DigitalMarketing />} />
          <Route path="/iot-development" element={<IOTDev />} />
          <Route path="/website-development" element={<WebSiteDev />} />
          <Route path="/seo" element={<SEO />} />
          <Route path="/qa-automation-testing" element={<QAAutomationTesting />} />
          {/* INDUSTRIES */}
          <Route path="/banking-and-financial" element={<BankingAndFinancial />} />
          <Route path="/education" element={<Education />} />
          <Route path="/energy-resources-utilities" element={<EnergyResourcesUtilities />} />
          <Route path="/insurance" element={<Insurance />} />
          <Route path="/life-sciences-healthcare" element={<LifeScienceHealthcare />} />
          <Route path="/public-services" element={<PublicServices />} />
          <Route path="/communications-media-technology" element={<CommunicationMedia />} />
          <Route path="/travel-transportation-logistics" element={<TravelMediaLogistics />} />
          <Route path="/information-services" element={<InformationServices />} />
          {/* PROJECT */}
          <Route path="/constrogen" element={<Constrogen />} />
          <Route path="/vby" element={<VBY />} />
          <Route path="/intellireader" element={<IntelliReader />} />
          <Route path="/ems" element={<EMS />} />
          <Route path="/vibro" element={<Vibro />} />
          <Route path="/etrm" element={<Skarvi />} />
        </Routes>
        <Footer/>
      </div>
    </Router>
  );
}

export default App;
